import { SectionImage } from 'services/api/vehicle-sections/types';
import { useLevel1SectionData } from './useLevel1Section';

export const useInteriorDamageImages = (): SectionImage[] => {
  const { images } = useLevel1SectionData('interior_questions');
  return images.filter((img: SectionImage) => !!img.is_damaged);
};
